import { ApplicationState } from 'clients/app/src/rootReducer';

const selectStudents = (state: ApplicationState) =>
  state.reports?.students ?? [];

export { selectStudents };
